import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const getSettingsValues = (): { [key: string]: unknown } => {
  return getGlobalProperty("settingsValues") || {};
};
